/** Панель «Комфортной среды»: чем закрашен раздел.
 *
 *  РАДИОГРУППА, а не два `ModelKind` — то же решение и по той же причине, что у
 *  механизмов апвеллинга: раздел есть набор асинхронных эффектов, и второй
 *  раздел размножил бы всю машинерию.
 *
 *  Список строится ИЗ КАТАЛОГА и режется по виду: подраздел виден только там,
 *  где модель есть (решение владельца 05.09.2026). Показанный у вида без модели,
 *  он дал бы пустую карту с кнопкой «Загрузить», которая её не исправит.
 */
import { useT } from '../i18n'
import type { HsiKind } from './hsiSelection'

interface Props {
  catalog: HsiKind[]
  kind: string
  onKind: (id: string) => void
}

export function HsiControl(p: Props) {
  const t = useT()
  // Один подраздел — переключать нечего, и радиогруппа из одной кнопки
  // сообщала бы о выборе, которого нет.
  if (p.catalog.length < 2) return null

  return (
    <div className="space-y-3">
      <section>
        <div className="eyebrow mb-1.5">{t('hsi.fillTitle')}</div>
        <div className="flex flex-col gap-1">
          {p.catalog.map(k => (
            <label
              key={k.id}
              className={`flex cursor-pointer items-center gap-2 rounded-lg px-2 py-1.5 text-sm transition-colors ${
                p.kind === k.id ? 'bg-hull/60 text-foam' : 'text-mist hover:text-foam'
              }`}
            >
              <input
                type="radio"
                name="hsi-kind"
                className="accent-sonar"
                checked={p.kind === k.id}
                onChange={() => p.onKind(k.id)}
              />
              <span className="flex-1">{t(`layers.${k.id}`)}</span>
              <span className="text-[10px] text-faint">{t(`units.${k.unit}`)}</span>
            </label>
          ))}
        </div>
      </section>

    </div>
  )
}
